import { render } from "./Tabla-Proyeccion.vue?vue&type=template&id=686fdc65&scoped=true"
import script from "./Tabla-Proyeccion.vue?vue&type=script&lang=js"
export * from "./Tabla-Proyeccion.vue?vue&type=script&lang=js"

import "./Tabla-Proyeccion.vue?vue&type=style&index=0&id=686fdc65&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-686fdc65"]])

export default __exports__